import React, { FC, useState } from 'react';
import { useGetAssignCompaniesList } from '../hooks/useGetAssignCompaniesList';
import {
  Box,
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import CompanyRow from './CompanyRow';
import { Company } from '@staffedupusa/shared-components';
import { EnterpriseTemplate } from '../types';

type CompaniesListProps = {
  templateData: EnterpriseTemplate;
};

const CompaniesList: FC<CompaniesListProps> = ({ templateData }) => {
  const [errorText, setErrorText] = useState('');
  const { companiesList, isLoadingCompaniesList } = useGetAssignCompaniesList({
    setErrorText,
    templateId: templateData?.id,
  });

  return (
    <TableContainer component={Paper}>
      {isLoadingCompaniesList ? (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100px',
          }}
        >
          <CircularProgress />
        </Box>
      ) : companiesList?.object?.length > 0 ? (
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>
                <b>Company Name</b>
              </TableCell>
              <TableCell>
                <b>Email</b>
              </TableCell>
              <TableCell>
                <b>Plan</b>
              </TableCell>
              <TableCell>
                <b>Action</b>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {companiesList.object.map((item: Company) => (
              <CompanyRow item={item} templateName={templateData?.name} />
            ))}
          </TableBody>
        </Table>
      ) : (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100px',
          }}
        >
          <Typography>No companies found</Typography>
        </Box>
      )}
    </TableContainer>
  );
};

export default CompaniesList;
